<template>
  <div>
    <masterList
      :tableColumns="tableColumns"
      :module="'employees'"
      :addNew="addNew"
    ></masterList>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import masterList from "../Components/masterList.vue";
export default {
  computed:{
    ...mapState({
         language_terms: state => state.languages.language_terms,
    })

  },
  components: {
    masterList,
  },

  data() {
    return {
      addNew: "/employee/_new",
       tableColumns: [
              {
                prop: 'code',
                label: 'CODE',
                minWidth: 60,
                sortable: true,
                headerAlign: 'left',             
                key:'CODE'
              },
              {
                prop: 'name',
                label: 'NAME',
                minWidth: 200,
                sortable: true,
                headerAlign: 'left',             
                key:'NAME'
              },
              {
                prop: 'uen',
                label: 'NRIC',
                minWidth: 80,
                sortable: true,
                headerAlign: 'right',             
                key:'NRIC'
              },
              {
                prop: 'balance',
                label: 'BALANCE',
                minWidth: 100,
                sortable: true,
                align: 'left',
                key:'BALANCE'
              },              
              {
                prop: 'contact_mobile',
                label: 'MOBILE',
                minWidth: 80,
                sortable: true,
                headerAlign: 'right',             
                key:'MOBILE'
              },              
              {
                prop: 'contact_email',
                label: 'EMAIL',
                minWidth: 160,
                sortable: true,
                key:'EMAIL'
              },
        ],

    };
  },
  watch:{
          language_terms: {
            handler(val){
                this.updateTableLang()
            },

        }

  },
  mounted(){
     this.updateTableLang()
  },
  methods:{
    updateTableLang(){
      for(let i=0; i<this.tableColumns.length;i++){
         let key = this.tableColumns[i].key
         this.tableColumns[i].label = this.language_terms[key]
      }
    }

  }
};
</script>

<style>
</style>